import React from 'react'
import { StyledALink, StyledLi, StyledNavLink, StyledUl } from './styled'
import { LinkHelperType } from './types'
import { useKindeAuth } from '@kinde-oss/kinde-auth-react'

const navLinks: LinkHelperType[] = [
  {
    name: 'תרגול AI',
    path: '/practice-ai'
  },
  {
    name: 'מבחן תאוריה',
    path: '/theory-test'
  },
  {
    name: 'לוח התמרורים',
    path: `road-sign-board`
  },
  {
    name: 'טיפים ומאמרים',
    path: `articles`
  }
]

interface NavigationProps {
  mobile?: boolean
  mode?: 'dark' | 'light' | undefined
}

export const Navigation: React.FC<NavigationProps> = ({ mobile, mode }) => {
  const { isAuthenticated, isLoading } = useKindeAuth()

  return (
    <StyledUl className={mobile ? 'mobile' : ''}>
      {navLinks &&
        navLinks.map((link) => (
          <StyledLi key={link.name}>
            {link.path === 'articles' || link.path === 'road-sign-board' ? (
              <StyledALink
                mode={mode}
                href={`${process.env.REACT_APP_DOMAIN}${link.path}`}
              >
                {link.name}
              </StyledALink>
            ) : (
              <StyledNavLink mode={mode} to={link.path}>
                {link.name}
              </StyledNavLink>
            )}
          </StyledLi>
        ))}
      {!isLoading && isAuthenticated && (
        <StyledLi>
          <StyledNavLink mode={mode} to={'/dashboard'}>
            אזור אישי
          </StyledNavLink>
        </StyledLi>
      )}
      {/* {!isLoading && isAuthenticated ? (
        <StyledLi>
          <StyledNavLink mode={mode} to={'/dashboard'}>
            אזור אישי{' '}
          </StyledNavLink>
        </StyledLi>
      ) : (
        <StyledLi>
          <StyledNavLink mode={mode} to={'/login'}>
            התחברות
          </StyledNavLink>
        </StyledLi>
      )} */}
    </StyledUl>
  )
}
